import { render } from "./ITCGridComponent.vue?vue&type=template&id=72f7bcf6&scoped=true"
import script from "./ITCGridComponent.vue?vue&type=script&lang=js"
export * from "./ITCGridComponent.vue?vue&type=script&lang=js"

import "./ITCGridComponent.vue?vue&type=style&index=0&id=72f7bcf6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f7bcf6"]])

export default __exports__